import { IEntry } from 'common/entities/courseWrapper/CourseWrapper';
import { Entity, Field } from 'typegraph';
import Product from 'panels/bundleEntries/entities/Product';
import CartItem from './CartItem';
import OrganizationSeatDistribution from './OrganizationSeatDistribution';
import { ID } from 'common/form/fields/entitySelect/IEntitySelect';


@Entity({many: "organizationEnrollment"})
export default class OrganizationEnrollments{


    @Field({entity:Product})
    public item : Product;

    @Field()
    public seatsPurchased:number
    
    @Field()
    public seatsRemaining:number

    @Field({entity: OrganizationSeatDistribution})
    public enrollmentDetails: OrganizationSeatDistribution[];
}





// WEBPACK FOOTER //
// ./src/panels/checkout/entities/OrganizationEnrollments.ts